import { cast, flow, Instance, types } from 'mobx-state-tree';
import { Script } from '../../http-requests';
import { IScript, IScriptFolder } from '../../components/script/types';
import { RequestStateModel } from './general-models';

const LastChangesModel = types.model({
  last_changes_date: types.optional(types.string, ''),
  person_position: types.optional(types.string, ''),
  updater_person: types.optional(types.string, ''),
});

const InstructionsModel = types
  .model({
    tab_content: types.optional(types.string, ''),
    last_changes: types.optional(types.array(LastChangesModel), []),
  })
  .actions((self) => ({
    setTabContent(value: string) {
      self.tab_content = value;
    },
  }));

export interface IInstructionsModel extends Instance<
  typeof InstructionsModel
> {}

export const ScriptStore = types
  .model({
    id: types.optional(types.string, ''),
    provider: types.optional(types.string, ''),
    call_card: types.optional(
      types.frozen<{ [key: string]: IInstructionsModel }>(),
      {}
    ),
    meter_transmission: types.optional(
      types.frozen<{ [key: string]: IInstructionsModel }>(),
      {}
    ),
    another: types.optional(
      types.frozen<{ [key: string]: IInstructionsModel }>(),
      {}
    ),
    requests: types.optional(
      types.frozen<{ [key: string]: IInstructionsModel }>(),
      {}
    ),
    loading: types.optional(RequestStateModel, {}),
  })
  .views((self) => ({
    getCurrentDescription(folder: IScriptFolder, tab: string): string {
      return self[folder]?.[tab]?.tab_content || '';
    },
  }))
  .actions((self) => ({
    setTabContent(
      folder: IScriptFolder,
      value: { [key: string]: IScript }
    ): void {
      self[folder] = cast(value);
    },
    // Получение данных скрипта
    getScript: flow(function* (id: string) {
      try {
        self.loading.fulfilled = false;
        self.loading.error = false;
        self.loading.pending = true;

        const response: { [key: string]: any } =
          yield Script.GetTabDescription(id);

        self = Object.assign(self, response);
        self.loading.fulfilled = true;
        return response;
      } catch (e) {
        self.loading.error = true;
        console.error(e);
      } finally {
        self.loading.pending = false;
      }
    }),
    // Изменение данных скрипта
    editScript: flow(function* (folder: IScriptFolder, tab: string) {
      try {
        self.loading.fulfilled = false;
        self.loading.error = false;
        self.loading.pending = true;

        const response = yield Script.PatchTabDescription(self.id, {
          [folder]: {
            [tab]: { tab_content: self[folder][tab].tab_content },
          },
        });

        self = Object.assign(self, response);
        self.loading.fulfilled = true;
        return response;
      } catch (e) {
        self.loading.error = true;
        console.error(e);
      } finally {
        self.loading.pending = false;
      }
    }),
  }));
